/**
 * CategoryRequestListPresenter
 * --
 */
import React, { useState } from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Text,
  Statistic,
  ModalLayout,
  Descriptions,
} from 'components';
import { Avatar, Button, DatePicker, Input, Radio, Select, Tag } from 'antd';
import { PictureOutlined, PlusOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';

const CategoryRequestListPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { data, categoryData, modalType, isOpened, onOpen, onSubmit } = props;
  /* ===== STATE ===== */

  const [selectedItem, setSelectedItem] = useState(null);

  const handleRowClick = (item) => {
    console.log(item);
    setSelectedItem(item);
    onOpen(isOpened, 'menu_info');
  };
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'카테고리 명'}
                options={[
                  { label: '카테고리 명', value: '카테고리 명' },
                  { label: '매장 명', value: '매장 명' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
              <Button size="large" icon={<PlusOutlined />} />
            </>
          ),
        },
      ],
    },
    {
      label: '카테고리 선택',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={
                  categoryData?.map((category) => ({
                    label: category.product_category_name,
                    value: category.product_category_id,
                  })) || []
                }
                style={{ ...styles.form.input.large }}
                placeholder={'카테고리 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '카테고리 신청일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '승인 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'승인'}>승인</Radio>
                <Radio value={'반려'}>반려</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  const newData = data?.map((item, index) => ({
    no: index + 1,
    카테고리: item.product_category_name,
    카테고리코드: item.product_category_id || '-',
    name: (
      <p style={{ display: 'flex', alignItems: 'center' }}>
        <Tag
          style={{
            background: 'none',
            color:
              item.application_status === 'APPLY'
                ? '#37383C'
                : item.application_status === 'APPROVE'
                ? '#58CF04'
                : '#EAA300',
            borderColor:
              item.application_status === 'APPLY'
                ? '#37383C'
                : item.application_status === 'APPROVE'
                ? '#58CF04'
                : '#EAA300',
            width: 48,
            fontSize: 8,
            fontWeight: 600,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {item.application_status === 'APPLY'
            ? '승인신청'
            : item.application_status === 'APPROVE'
            ? '승인'
            : item.application_status === 'REJECT'
            ? '반려'
            : '대기'}
        </Tag>
        {item.product_category_name || '-'}
      </p>
    ),
    order: item.order,
    parent_id: item.parent_id,
    판매처: (
      <button
        style={{
          border: 'none',
          background: 'none',
          textDecoration: 'underline',
          color: '#1C6BFF',
          cursor: 'pointer',
        }}
      >
        {item.shop_name}
      </button>
    ),
    승인상태: (
      <Select
        value={item.application_status}
        options={[
          { label: '승인신청', value: 'APPLY' },
          { label: '승인', value: 'APPROVE' },
          { label: '반려', value: 'REJECT' },
        ]}
        style={{ ...styles.form.input.medium }}
        onChange={(value) => onSubmit('MENU', 'UPDATE', item.menu_id, value)}
      />
    ),
    menu_data: { ...item },
  }));

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>카테고리 목록</Title>

            {/* 요약 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40, display: 'flex' }}
            >
              {[
                { title: '전체 신청', value: 0 },
                { title: '전체 승인', value: 0 },
                { title: '전체 반려', value: 0 },
                { title: '오늘 신청', value: 0 },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `calc(100% / 4)`,
                    marginRight: _index === 4 ? 0 : 4,
                    padding: 20,
                  }}
                >
                  <Statistic
                    title={_item.title}
                    value={_item.value}
                    suffix={'건'}
                    direction={'row'}
                    style={{ justifyContent: 'center' }}
                  />
                </div>
              ))}
            </Content>
            {/* 요약 끝 */}

            {/* 검색필터 */}
            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40 }}
            >
              <ExpandableContainer borderRadius={4} padding={20}>
                {formItem.map((_item, _index) => (
                  <div
                    key={`form_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '10px 0px',
                    }}
                  >
                    <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                      <label>{_item.label}</label>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {_item.form.map((_subitem, _subkey) => (
                        <React.Fragment key={`input_${_subkey}`}>
                          {_subitem.input}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                ))}
              </ExpandableContainer>

              {/* 검색/초기화 버튼 */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  marginTop: 48,
                }}
              >
                <Button
                  size="large"
                  type="primary"
                  style={{
                    ...styles.button,
                    background: 'var(--primary-color)',
                  }}
                >
                  검색
                </Button>
                <Button size="large" style={{ ...styles.button }}>
                  초기화
                </Button>
              </div>
              {/* 검색/초기화 버튼 끝 */}
            </Content>
            {/* 검색필터 끝 */}

            {/* 검색결과 */}
            <Content
              maxWidth={'100%'}
              borderRadius={4}
              padding={20}
              style={{ minHeight: 530 }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 20,
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <h4
                    style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}
                  >
                    총 <span>0</span>건
                  </h4>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    진열안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    판매안함
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    복사
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    삭제
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    분류수정
                  </Button>
                  <Button size="large" style={{ marginRight: 8 }}>
                    메인진열수정
                  </Button>
                </div>
                <div>
                  <Select
                    size="large"
                    value={'신청일순'}
                    options={[
                      { label: '신청일순', value: '신청일순' },
                      { label: '신청일순2', value: '신청일순2' },
                    ]}
                  />
                </div>
              </div>
              <Table
                data={newData}
                isChecked
                onRow={(item) => handleRowClick(item)}
                columns={[
                  {
                    title: 'No',
                    key: 'no',
                    width: 10,
                  },
                  {
                    title: '카테고리',
                    key: '카테고리',
                  },
                  {
                    title: '카테고리코드',
                    key: '카테고리코드',
                  },
                  {
                    title: '카테고리명',
                    key: 'name',
                    width: 300,
                  },
                  {
                    title: '순서',
                    key: 'order',
                  },
                  {
                    title: '상위카테고리id',
                    key: 'parent_id',
                  },
                  {
                    title: '상위카테고리 명',
                    key: 'parent_name',
                  },
                  {
                    title: '판매처',
                    key: '판매처',
                  },
                  {
                    title: '승인상태',
                    key: '승인상태',
                  },
                ]}
              />
            </Content>
            {/* 검색결과 끝 */}
          </Col>
        </Row>
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={isOpened && modalType === 'menu_info'}
        onCancel={() => onOpen(isOpened)}
        centered
        closable
        title={'메뉴정보'}
        width={884}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Button onClick={() => onOpen(isOpened)}>닫기</Button>
              </Col>
            </Row>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          padding={'20px 0'}
          style={{
            borderTop: '1px solid #F4F4F5',
            borderBottom: '1px solid #F4F4F5',
          }}
        >
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={10}>
                <Descriptions
                  align="left"
                  column={4}
                  items={[
                    {
                      key: `1`,
                      label: '메뉴명',
                      children: selectedItem?.menu_data?.menu_name
                        ? selectedItem?.menu_data?.menu_name
                        : '-',
                      span: 2,
                    },
                    {
                      key: `2`,
                      label: '메뉴번호',
                      children: selectedItem?.menu_data?.menu_id
                        ? '0000' + selectedItem?.menu_data?.menu_id
                        : '-',
                      span: 2,
                    },
                    {
                      key: `3`,
                      label: '단가',
                      children: selectedItem?.menu_data?.price
                        ? stringToMoneyFormat(
                            selectedItem?.menu_data?.price,
                            '원'
                          )
                        : '-',
                      span: 4,
                    },
                    {
                      key: `4`,
                      label: '설명',
                      children: selectedItem?.menu_data?.menu_content
                        ? selectedItem?.menu_data?.menu_content
                        : '-',
                      span: 4,
                    },
                    {
                      key: 5,
                      label: '기타옵션',
                      children: !selectedItem?.menu_data?.menu_option
                        ? '-'
                        : selectedItem?.menu_data?.menu_option?.map(
                            (option, _index, _arr) => (
                              <div
                                key={`option_${_index}`}
                                style={{
                                  padding: '10px 20px',
                                  borderBottom:
                                    _arr.length === _index + 1
                                      ? 'none'
                                      : '1px solid rgba(112, 115, 124, 0.2)',
                                }}
                              >
                                <Text size={13} weight={600} color={'#454545'}>
                                  {option.option_title || 'Option'}
                                </Text>
                                <Radio.Group
                                  style={{ marginTop: 8 }}
                                  value={''}
                                >
                                  {option.option?.map((_item) => (
                                    <Radio
                                      key={`item_${_item.option_key}`}
                                      value={_item}
                                    >
                                      {_item.option_name || 'Option Name'}
                                    </Radio>
                                  ))}
                                </Radio.Group>
                              </div>
                            )
                          ),
                      span: 4,
                      style: { padding: 0 },
                    },
                    {
                      key: `6`,
                      label: '이미지',
                      children: (
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            padding: '20px 0px',
                          }}
                        >
                          {selectedItem?.menu_data?.files?.map((_, _index) => (
                            <Avatar
                              key={`img_${_index}`}
                              size={100}
                              shape="square"
                              style={{ marginRight: 10 }}
                              src={_}
                            />
                          ))}
                        </div>
                      ),
                      span: 4,
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default CategoryRequestListPresenter;
